var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWfMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "inactive-nav-icon",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 15C1.5 14.4696 1.71071 13.9609 2.08579 13.5858C2.46086 13.2107 2.96957 13 3.5 13H5.5C6.03043 13 6.53914 13.2107 6.91421 13.5858C7.28929 13.9609 7.5 14.4696 7.5 15V17C7.5 17.5304 7.28929 18.0391 6.91421 18.4142C6.53914 18.7893 6.03043 19 5.5 19H3.5C2.96957 19 2.46086 18.7893 2.08579 18.4142C1.71071 18.0391 1.5 17.5304 1.5 17V15Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 15C13.5 14.4696 13.7107 13.9609 14.0858 13.5858C14.4609 13.2107 14.9696 13 15.5 13H17.5C18.0304 13 18.5391 13.2107 18.9142 13.5858C19.2893 13.9609 19.5 14.4696 19.5 15V17C19.5 17.5304 19.2893 18.0391 18.9142 18.4142C18.5391 18.7893 18.0304 19 17.5 19H15.5C14.9696 19 14.4609 18.7893 14.0858 18.4142C13.7107 18.0391 13.5 17.5304 13.5 17V15Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3C7.5 2.46957 7.71071 1.96086 8.08579 1.58579C8.46086 1.21071 8.96957 1 9.5 1H11.5C12.0304 1 12.5391 1.21071 12.9142 1.58579C13.2893 1.96086 13.5 2.46957 13.5 3V5C13.5 5.53043 13.2893 6.03914 12.9142 6.41421C12.5391 6.78929 12.0304 7 11.5 7H9.5C8.96957 7 8.46086 6.78929 8.08579 6.41421C7.71071 6.03914 7.5 5.53043 7.5 5V3Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13V12C4.5 11.4696 4.71071 10.9609 5.08579 10.5858C5.46086 10.2107 5.96957 10 6.5 10H14.5C15.0304 10 15.5391 10.2107 15.9142 10.5858C16.2893 10.9609 16.5 11.4696 16.5 12V13",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7V10",
    stroke: "#5E5E5E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWfMain);
export default __webpack_public_path__ + "static/media/WFMain.9162a69be0cdc84ec0a70d23fcedf480.svg";
export { ForwardRef as ReactComponent };